import { api } from './client';

/**
 * "Lo que falta configurar": las tareas del cliente dentro de su panel, y la
 * aprobación de cómo se agrupan las zonas viejas. Todo de ADMIN para arriba.
 */

export type AccionTarea = 'modelos' | 'guia' | 'zonas' | 'mapas';

export interface TareaCliente {
  id: string;
  titulo: string;
  porque: string;
  hecho: boolean;
  detalle?: string;
  accion: AccionTarea;
  guia?: string;
}

export interface TareaPersonal {
  id: string;
  titulo: string;
  detalle: string | null;
  hecho: boolean;
  creadaPor: string;
  creadaEl: string;
  hechaEl: string | null;
}

export interface TareasDelCliente {
  tareas: TareaCliente[];
  resumen: { hechas: number; total: number; completo: boolean };
  personales: TareaPersonal[];
  oculto: boolean;
  modelosPorConfirmar: string[];
  modelosCargados: { nombre: string; meses: number }[];
}

export interface GrupoZona {
  clave: string;
  propuesta: string;
  enCatalogo: boolean;
  trabajos: number;
  variantes: { zona: string; trabajos: number }[];
  porRevisar: boolean;
}

export interface PropuestaZonas {
  grupos: GrupoZona[];
  sinZona: number;
  porRevisar: number;
  catalogo: string[];
  aprobadaEl: string | null;
}

export const obtener = () => api.get<TareasDelCliente>('/api/tareas-cliente');

export const agregarPersonal = (titulo: string, detalle?: string) =>
  api.post<TareaPersonal>('/api/tareas-cliente/personales', { titulo, detalle: detalle || null });

export const marcarPersonal = (id: string, hecho: boolean) =>
  api.patch<{ ok: boolean }>(`/api/tareas-cliente/personales/${id}`, { hecho });

export const borrarPersonal = (id: string) =>
  api.del<{ ok: boolean }>(`/api/tareas-cliente/personales/${id}`);

export const ocultar = (oculto: boolean) =>
  api.put<{ ok: boolean }>('/api/tareas-cliente/oculto', { oculto });

export const decidirMapas = (decision: 'manual' | 'automatico') =>
  api.put<{ ok: boolean }>('/api/tareas-cliente/mapas', { decision });

export const responderModelos = (
  respuestas: { nombre: string; meses?: number; noEsModelo?: boolean }[],
) => api.post<{ agregados: number; quedan: number }>('/api/tareas-cliente/modelos', { respuestas });

export const propuestaDeZonas = () => api.get<PropuestaZonas>('/api/zonas/agrupacion');

export const aprobarZonas = (grupos: { variantes: string[]; destino: string }[]) =>
  api.post<{ trabajosCambiados: number; zonasAgregadasAlCatalogo: string[] }>(
    '/api/zonas/agrupacion/aprobar',
    { grupos },
  );
